var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.status)?_c(_vm.component,{tag:"component",on:{"update":_vm.onUpdate,"showTitleOnHeader":_vm.onShowTitleOnHeader,"reset":_vm.onReset}},[_vm._t("default")],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }